// @flow
import type { Request } from '../../index';


export type Result = {
  enabled: boolean,
  allow_vending_external_service: boolean,
}

export const defaultSettings: Result = {
  enabled: false,
  allow_vending_external_service: false,
};

export const GET_VENDING_SETTINGS: Request<void, Result, void> = [
  'data/vending/settings',
  'get',
  ['data', 'data'],
];
